import { Component, OnInit,ViewChild } from '@angular/core';
import { forgotPassword } from '../models/forgetPassword';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
forgotPassWordAddObj:forgotPassword;
confirmPassword:any
userSessionData:any
userDetails:any
@ViewChild("chnagePassword") form: any;

  constructor(private cs:CucurachaAdminService , private toastr: ToastrManager) { 
    this.forgotPassWordAddObj=new forgotPassword()
  }

    changePassword(){
      if (this.forgotPassWordAddObj.resetPassword == this.confirmPassword) {
        this.forgotPassWordAddObj.userName = this.userDetails._id;

      this.cs.changePassword(this.forgotPassWordAddObj).subscribe((data) => {
        if (data.result) {
          this.toastr.successToastr(data.message);
          this.form.reset()
         // this.showSignIn = true

        }
        else if (data.err) {
          this.toastr.warningToastr(data.message);

        }
        else {
          this.toastr.errorToastr(data.message);

        }
      })
    }
    else {
      this.toastr.warningToastr("You must enter reset password and confirm password should be same")
    }
    }
  ngOnInit(): void {
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))
    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails = data[0]
         })
  }

}
